import MercadoIndex from './MercadoIndex'

export const mercadoRoutes = [
  { name: 'mercado-index', path: '/relatorio-mercado', component: MercadoIndex }
]
